import React from 'react';
import { FiSearch, FiMessageSquare, FiVideo } from 'react-icons/fi';
import { useAuth } from '../../contexts/AuthContext';
import { useNavigate } from 'react-router-dom';

const Header: React.FC = () => {
  const { logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    try {
      await logout();
      navigate('/login');
    } catch (error) {
      console.error('Failed to log out', error);
    }
  };

  return (
    <header className="bg-uc-navy text-white shadow-lg">
      <div className="max-w-7xl mx-auto px-4 py-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center">
            <div className="w-12 h-12 bg-white rounded mr-3 flex items-center justify-center p-1">
              <img src="/logo.png" alt="UC Merced Logo" className="w-full h-full object-contain" />
            </div>
            <div>
              <h1 className="text-xl font-bold font-header">MyStudentPortal</h1>
            </div>
          </div>

          <div className="flex items-center space-x-4">
            <button className="hover:text-uc-gold transition-colors" title="Search">
              <FiSearch size={20} />
            </button>
            <button className="hover:text-uc-gold transition-colors" title="Messages">
              <FiMessageSquare size={20} />
            </button>
            <button className="hover:text-uc-gold transition-colors" title="Video">
              <FiVideo size={20} />
            </button>
            <button
              onClick={handleLogout}
              className="bg-uc-gold text-uc-navy px-4 py-2 rounded hover:bg-yellow-400 transition-colors font-semibold text-sm"
            >
              Sign Out
            </button>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
